import { API } from "../../../utils";

export const getReportSettingsListApi = async () => {
  const res = await API.get(`report-classes`);
  return res.data;
};

export const createReportClassApi = async (data) => {
  const res = await API.post(`report-classes`, data);
  return res.data;
};

export const createReportCategoryApi = async (data) => {
  const res = await API.post(`report-categories`, data);
  return res.data;
};
